var hostname = window.location.hostname;
export const getEnv = () => {
  console.log(hostname, "env.js1111222");
  switch (hostname) {
    case "localhost":
      // return 'http://lyyzuat-api.prime-algae.com'; //测试环境
      //return 'https://scm-api-dev-v2.v5q.cn';
      // return 'http://scm-api-qa-v2.f349.cn:8082';
      return "https://qrcodeuat.kraftheinz.net.cn/api-gateway";
    case "major-project-dev.v5q.cn":
      // return 'http://major-project-dev.v5q.cn';//dev配置
      return "https://scm-api-dev-v2.v5q.cn";
    // default:return 'https://scm-api-ty-qa.doterra.cn';
    case "major-project-qa.v5q.cn":
      console.log("ceshihuangjing-ceshi"); //dev配置
      // return 'http://scm-api-dev.f349.cn:8081';// ---开发环境
      return "http://scm-api-qa-v2.f349.cn:8082"; //测试环境
    // default:return 'https://scm-api-ty-qa.doterra.cn';
    case "lyyzuat-web.prime-algae.com":
      console.log("莱茵衣藻");
      return "http://lyyzuat-api.prime-algae.com"; //测试环境
    case "lyyzuatcdn.prime-algae.com":
      console.log("莱茵衣藻临时");
      return "http://lyyzuat-api.prime-algae.com"; //测试环境
    case "lyyz-web.prime-algae.com":
      console.log("莱茵衣藻正式");
      return "http://lyyz-api.prime-algae.com"; //测试环境
    case "lyyz-uat-1255460314.cos.ap-beijing.myqcloud.com":
      console.log("莱茵衣藻qa无cdn");
      return "http://lyyzuat-api.prime-algae.com"; //测试环境
    case "weishida.sao.so":
      return "https://weishida-top.sao.so"; //味事达开发配置
    case "qrcodeuat.kraftheinz.net.cn":
      return "https://qrcodeuat.kraftheinz.net.cn/api-gateway"; //味事达测试配置
    case "qrcode.kraftheinz.net.cn":
      return "https://qrcode.kraftheinz.net.cn/api-gateway"; //味事达正式配置
    case "192.168.2.137":
      console.log("天狮qa环境");
      return "http://192.168.2.137:9012"; //天狮qa环境
    case "192.168.2.132":
      return "http://192.168.2.132:9012"; //天狮pord环境
    case "127.0.0.1": //entCode=heinz
      // return 'https://weishida-top.sao.so'; //本地测试环境
      return "https://qrcodeuat.kraftheinz.net.cn/api-gateway"; //味事达测试配置
  }
};



// WEBPACK FOOTER //
// ./src/utils/env.js